<template>
  <form @submit.prevent="save" class="space-y-6 lg:grid lg:grid-cols-2 lg:gap-x-6">
    <fieldset class="col-span-2">
      <legend class="block text-sm font-medium leading-5 text-hurst-blue">
        Your Degree Type
      </legend>
      <div class="mt-1 flex items-center space-x-10">
        <div v-for="type in degreeTypes" :key="type.value" class="flex items-center">
          <input :id="type.value" name="degreeType" type="radio" v-model="form.degreeType" :value="type.value"
                 class="h-4 w-4 border-2 border-hurst-blue text-hurst-blue focus:ring-hurst-blue">
          <label :for="type.value"
                 class="ml-3 block text-sm font-medium leading-6 text-hurst-blue">{{ type.label }}</label>
        </div>
      </div>
      <p class="text-brand-orange-500 text-base font-medium italic"
         v-if="errors.hasOwnProperty('degreeType')">
        {{ errors.degreeType[0] }}</p>
    </fieldset>
    <div class="grid grid-cols-1 lg:grid-cols-2 lg:col-span-2 gap-y-6 lg:gap-6">
      <div>
        <label class="block text-sm font-medium leading-5 text-hurst-blue" for="firstName">
          <span class="text-red-500 text-lg">*</span>
          Name
        </label>
        <div class="mt-1 md:mt-0 rounded shadow-sm">
          <input
              class="appearance-none block w-full px-3 py-2 border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              :class="{'border-red-500': errors.hasOwnProperty('firstName'), 'border-brand-gray-300': !errors.hasOwnProperty('firstName')}"
              v-model="form.firstName"
              required
              autocomplete="given-name"
              id="firstName" type="text" placeholder="First Name">
          <p class="text-brand-orange-500 text-sm font-medium italic"
             v-if="errors.hasOwnProperty('firstName')">
            {{ errors.firstName[0] }}</p>
        </div>
      </div>
      <div class="lg:flex items-end w-full">
        <label class="sr-only" for="lastName">
          Last Name
        </label>
        <div class="mt-1 md:mt-0 w-full"
             :class="{'border-red-500': errors.hasOwnProperty('lastName')}"
        >
          <input
              class="w-full appearance-none block w-full px-3 py-2 border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              :class="{'border-red-500': errors.hasOwnProperty('lastName'), 'border-brand-gray-300': !errors.hasOwnProperty('lastName')}"
              v-model="form.lastName"
              autocomplete="family-name"
              required
              id="lastName" type="text" placeholder="Last Name">
          <p class="text-brand-orange-500 text-sm font-medium italic"
             v-if="errors.hasOwnProperty('lastName')">
            {{ errors.lastName[0] }}</p>
        </div>
      </div>
    </div>
    <div class="col-span-2 lg:grid lg:grid-cols-2 lg:gap-x-6">
      <div><label class="block text-sm font-medium leading-5 text-hurst-blue" for="emailAddress">
        <span class="text-red-500 text-lg">*</span>
        Email Address
      </label>
        <div class="mt-1 md:mt-0">
          <input
              class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              :class="{'border-red-500': errors.hasOwnProperty('emailAddress'), 'border-brand-gray-300': !errors.hasOwnProperty('emailAddress')}"
              v-model="form.emailAddress"
              required
              autocomplete="email"
              id="emailAddress" type="email" placeholder="jane.doe@example.com">
          <p class="text-brand-orange-500 text-sm font-medium italic"
             v-if="errors.hasOwnProperty('emailAddress')">
            {{ errors.emailAddress[0] }}</p>
        </div>
      </div>
    </div>
    <div class="col-span-2 lg:grid lg:grid-cols-2 lg:gap-x-6">
      <div><label class="block text-sm font-medium leading-5 text-hurst-blue" for="mobilePhone">
        <span class="text-red-500 text-lg">*</span>
        Mobile Phone
      </label>
        <div class="mt-1 md:mt-0">
          <input
              class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              :class="{'border-red-500': errors.hasOwnProperty('phone'), 'border-brand-gray-300': !errors.hasOwnProperty('phone')}"
              v-model="form.phone"
              required
              id="mobilePhone" type="tel" placeholder="xxx-xxx-xxxx">
          <p class="text-brand-orange-500 text-sm font-medium italic" v-if="errors.hasOwnProperty('phone')">
            {{ errors.phone[0] }}</p>
        </div>
      </div>
    </div>
    <div class="col-span-2 lg:grid lg:grid-cols-2 lg:gap-x-6">
      <div><label class="block text-sm font-medium leading-5 text-hurst-blue" for="password">
        <span class="text-red-500 text-lg">*</span>
        Password
      </label>
        <div class="mt-1 md:mt-0">
          <input
              class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              :class="{'border-red-500': errors.hasOwnProperty('password'), 'border-brand-gray-300': !errors.hasOwnProperty('password')}"
              v-model="form.password"
              required
              autocomplete="new-password"
              id="password" type="password">
          <p class="text-brand-orange-500 text-sm font-medium italic"
             v-if="errors.hasOwnProperty('password')">
            {{ errors.password[0] }}</p>
        </div>
      </div>
    </div>
    <div class="col-span-2 lg:grid lg:grid-cols-2 lg:gap-x-6">
      <div><label class="block text-sm font-medium leading-5 text-hurst-blue" for="confirm_password">
        <span class="text-red-500 text-lg">*</span>
        Confirm Password
      </label>
        <div class="mt-1 md:mt-0">
          <input
              class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              :class="{'border-red-500': errors.hasOwnProperty('confirm_password'), 'border-brand-gray-300': !errors.hasOwnProperty('confirm_password')}"
              v-model="form.confirm_password"
              required
              autocomplete="new-password"
              id="confirm_password" type="password">
          <p class="text-brand-orange-500 text-sm font-medium italic"
             v-if="errors.hasOwnProperty('confirm_password')">{{ errors.confirm_password[0] }}</p>
        </div>
      </div>
    </div>
    <div class="col-span-2 lg:grid lg:grid-cols-2 lg:gap-x-6">
      <div><label class="block text-sm font-medium leading-5 text-hurst-blue" for="nursingSchoolState">
        <span class="text-red-500 text-lg">*</span>
        Your Nursing School's State or Province
      </label>
        <div class="mt-1 md:mt-0"
             :class="{'border-red-500': errors.hasOwnProperty('nursingSchoolState')}"
        >
          <div class="relative w-full">
            <select id="nursingSchoolState"
                    class="form-select text-brand-gray-500 appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="form.nursingSchoolState"
                    @change="loadSchools">
              <option value="" class="text-brand-gray-500" disabled>-- Select A State/Province --</option>
              <option value="non-us-ca" class="text-hurst-blue">Outside of The US / Canada</option>
              <option disabled>----------------------------</option>
              <option class="text-hurst-blue" v-for="state in stateProvince" :key="state.abbreviation"
                      :value="state.abbreviation">{{ state.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-span-2 lg:grid lg:grid-cols-2 lg:gap-x-6">
      <div><label class="block text-sm font-medium leading-5 text-hurst-blue" for="nursingSchool">
        <span class="text-red-500 text-lg">*</span>
        Your Nursing School
      </label>
        <div class="mt-1 md:mt-0">
          <div class="relative w-full">
            <select id="nursingSchool"
                    class="form-select text-brand-gray-500 appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    :class="{'border-red-500': errors.hasOwnProperty('nursingSchoolId'), 'border-brand-gray-300': !errors.hasOwnProperty('nursingSchoolId')}"
                    v-model="form.nursingSchoolId"
                    :disabled="schools.length < 1"
            >
              <option value="" class="text-brand-gray-500" v-if="schools.length > 0">-- Select Your School --</option>
              <option value="" class="text-brand-gray-500" v-else disabled>-- Select Your School's State --</option>
              <option class="text-hurst-blue" v-for="school in schools" :key="school.schoolId" :value="school.schoolId">
                {{ school.schoolName }}
              </option>
            </select>
            <p class="text-brand-orange-500 text-sm font-medium italic"
               v-if="errors.hasOwnProperty('nursingSchoolId')">{{ errors.nursingSchoolId[0] }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-span-2 lg:grid lg:grid-cols-2 lg:gap-x-6">
      <div><label class="block text-sm font-medium leading-5 text-hurst-blue" for="gradDate">
        <span class="text-red-500 text-lg">*</span>
        Your Graduation Date
      </label>
        <div class="mt-1 md:mt-0">
          <div class="relative w-full">
            <v-date-picker
                :input-props='{
                                id: "gradDate",
                                class: pickerClasses,
                                placeholder: "Graduation Date"
                            }'
                is-dark
                color="indigo"
                v-model="graduationInput"></v-date-picker>
          </div>
          <p class="text-brand-orange-500 text-sm font-medium italic"
             v-if="errors.hasOwnProperty('graduationDate')">{{ errors.graduationDate[0] }}</p>
        </div>
      </div>
    </div>
    <div class="col-span-2 flex justify-start">
      <cart-button type="submit">
        Create Account & Continue
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
        </svg>
      </cart-button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2';
import CartButton from "./CartButton.vue";

export default {
  name: "CreateAccountForm",
  components: {CartButton},

  props: {
    stateProvince: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      errors: {},
      degreeTypes: [
        {label: 'RN: BSN', value: 'BSN'},
        {label: 'RN: ADN', value: 'ADN'},
        {label: 'LPN/LVN', value: 'LPN'}
      ],
      form: {
        confirm_password: '',
        degreeType: '',
        emailAddress: '',
        firstName: '',
        graduationDate: '',
        lastName: '',
        phone: '',
        nursingSchoolId: '',
        nursingSchoolState: '',
        password: '',
        schoolState: '',
        username: ''
      },
      graduationInput: '',
      schools: []
    }
  },

  computed: {
    pickerClasses() {
      const base = ["appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"];
      if (this.errors.hasOwnProperty('graduationDate')) {
        base.push("border-red-500");
      } else {
        base.push("border-brand-gray-300");
      }

      return base.join(" ");
    },

    hasErrors() {
      return Object.keys(this.errors).length > 0;
    }
  },

  watch: {
    'form.emailAddress': function (newEmailAddress, oldEmailAddress) {
      this.form.username = newEmailAddress;
    },
    graduationInput: function (newDate, oldDate) {
      this.form.graduationDate = moment(newDate).format('YYYY-MM-DD');
    }
  },

  methods: {
    async loadSchools() {
      try {
        const {data} = await axios.get(`/ajax/schoolByState/${this.form.nursingSchoolState}`);
        this.schools = data;
      } catch (e) {
        this.errors = e.response.data;
      }
    },

    async save() {
      this.errors = {};
      Swal.fire({
        title: 'Please Wait',
        html: 'We are creating your account<br/><i class="fal fa-spinner fa-spin fa-3x mt-10"></i>',
        showCloseButton: false,
        showConfirmButton: false,
        icon: 'info'
      });
      try {
        const response = await axios.post('/api/users', this.form);
        window.location = '/Checkout';
      } catch (e) {
        this.errors = Object.assign({}, this.errors, e.response.data);
        Swal.close();
      }
    }
  },
}
</script>

<style scoped>

</style>